module.exports = __webpack_public_path__ + "media/de_de_s2_Hannah.debf04d7.mp3";